import ProductInfo from "./productInfo";

const ProductDatas = ({ activeVariant, productDetails }) => {
  return (
    <div className="mt-24">
      <div className="product-details__content">
        <h4 className="mb-8 fw-bold">{activeVariant?.title}</h4>
        <div className="flex-align flex-wrap gap-12 mb-16">
          <div className="flex-align gap-12 flex-wrap">
            <div className="flex-align gap-4">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="text-xs fw-medium text-warning-600 d-flex">
                  <i className="ph-fill ph-star" />
                </span>
              ))}
            </div>
            <span className="text-sm fw-semibold text-neutral-600">
              4.7
            </span>
            <span className="text-sm text-gray-400">(21,671 reviews)</span>
          </div>
          <span className="text-gray-300">|</span>
          <span className="text-sm text-gray-600">
            <span className="text-gray-400">Category: </span>
            {productDetails?.sub_category?.name}
          </span>
          {productDetails?.label && (
            <span className="product-card__badge bg-danger-600 px-10 py-4 text-xs text-white fw-semibold rounded-pill">
              {productDetails?.label}
            </span>
          )}
        </div>

        <div
          className="py-16 mb-16"
          style={{ borderTop: "1px solid #f0f0f0", borderBottom: "1px solid #f0f0f0" }}
        >
          <div className="d-flex align-items-end gap-12 flex-wrap">
            <h3 className="mb-0 fw-bold" style={{ color: "var(--main-600)" }}>
              ₹{activeVariant?.sale_price}
            </h3>
            <span className="text-gray-500 fw-normal text-sm mb-1">
              /{activeVariant?.quantity}
            </span>
            {activeVariant?.price !== activeVariant?.sale_price && (
              <>
                <span className="text-md text-gray-400 text-decoration-line-through mb-1">
                  ₹{activeVariant?.price}
                </span>
                <span className="text-xs fw-bold text-white bg-success-600 px-8 py-4 rounded-pill mb-1">
                  {Math.round(((activeVariant?.price - activeVariant?.sale_price) / activeVariant?.price) * 100)}% OFF
                </span>
              </>
            )}
          </div>
        </div>

        <div className="d-flex align-items-center gap-12 mb-16">
          <span
            className="w-36 h-36 flex-center rounded-circle text-sm"
            style={{ background: "#fff3e0", color: "#f57c00" }}
          >
            <i className="ph-fill ph-lightning" />
          </span>
          <span className="text-sm fw-semibold text-gray-900">
            Available only: <span className="text-danger-600">{activeVariant?.stock} in stock</span>
          </span>
        </div>

        {productDetails?.description && (
          <div className="mb-16 d-none d-md-block">
            <h6 className="text-sm fw-bold text-heading mb-8 text-uppercase">Description</h6>
            <p className="text-gray-600 text-sm mb-0" style={{ lineHeight: "1.7" }}>
              {productDetails?.description}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProductDatas;
